import type { LinkButton } from '@sats-group/ui-lib/react/link-button/link-button.types';
import type { ValueOf } from 'type-fest';

export const themes = {
  primary: 'primary',
  secondary: 'secondary',
  featured: 'featured',
} as const;

export const variants = {
  cta: 'cta',
  secondary: 'secondary',
} as const;

export type CTABanner = {
  link: LinkButton;
  text: string;
  theme?: ValueOf<typeof themes>;
  title: string;
  variant?: ValueOf<typeof variants>;
};
